import React from "react";

function Home() {
    return (
        // Use a fragment (<>) to return multiple top-level elements
        <>
            {/* 1. Full-width Background Image Banner (Empty) */}
            <div className="home-background w-100">
                {/* This div is now empty and solely provides the background image effect */}
            </div>

            {/* 2. Content Container (Starts below the image banner) */}
            <div className="container mt-5">
                {/* The Welcome/Hero Content - We PUT BACK the bg-light class for contrast */}
                <div className="p-5 mb-4 bg-light rounded-3">
                    <div className="container-fluid py-5">
                        <h1 className="display-5 fw-bold">
                            Connect Everything
                        </h1>
                        {/* ... rest of the text content ... */}
                    </div>
                </div>

                {/* 3. Content Row (Optional: Feature Cards) */}
                <div className="row">
                    {/* ... About Us, Services, etc. ... */}
                </div>
            </div>
        </>
    );
}

export default Home;
